module.exports = __webpack_public_path__ + "img/stella-6.b35c591.jpg";